<template>
<div class="panel" id="news-list-panel">
    <div class="panel-title">
        Autres actualités
        <hr>
    </div>
    <div v-if="filteredNewsList.length === 0" class="panel-content">
      <spinner></spinner>
    </div>
    <div v-else class="panel-content">
        <div v-for="item in filteredNewsList" class="news">
            <div class="row columns">
                  <div class="medium-4 columns">
                      <router-link id="news-list-img-link" v-if="item.featured_image" :to="{ name: 'NewsDetail', params: { id: item.id.toString() }}"><img v-bind:src="item.featured_image" alt="aperçu"></router-link>
                      <router-link id="news-list-img-link" v-else :to="{ name: 'NewsDetail', params: { id: item.id.toString() }}"><img src="http://lorempixel.com/640/480/" alt="aperçu"></router-link>
                  </div>
                  <div class="medium-8 columns">
                      <router-link id="news-list-title-link" :to="{ name: 'NewsDetail', params: { id: item.id }}"><h4 class="news-title">{{item.title}}</h4></router-link>
                      <p class="news-infos">
                          <span><i class="fa fa-user" aria-hidden="true"></i>par {{item.user.username}}</span>
                          <span><i class="fa fa-calendar" aria-hidden="true"></i>le {{ item.created | formatDate}}</span>
                          <span><i class="fa fa-comments" aria-hidden="true"></i>{{item.comments_count}} commentaires</span>
                          <span><i class="fa fa-heart" aria-hidden="true"></i>{{item.likes}} likes</span>
                      </p>
                      <div class="abstract">
                      {{item.description}}
                      </div>
                  </div>
            </div>
            <hr>
        </div>
        <div class="row">
          <div class="large-5 column">
              <router-link id="news-list-bottom-link" :to="{ name: 'NewsList'}"class="left-bottom-link">Toutes les actualités...</router-link>
          </div>
          <div class="large-7  column">
              <paginate :click-handler="paginateClickCallback"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :page-count="pageCount"
                  :container-class="'pagination'">
              </paginate>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import store from '../../store/index.js'
import { mapGetters } from 'vuex'
import spinner from '../common/spinner.vue'
import formatDate from '../../common/filters.js'
import Paginate from 'vuejs-paginate'

export default {
  name: 'newsListPanel',
  components: {
    spinner,
    Paginate
  },
  data () {
    return {
    }
  },
  computed:
  {
    ...mapGetters([
      'filteredNewsList',
      'pageCount'
    ])
  },
  filters: {
    formatDate
  },
  methods: {
    paginateClickCallback (pageNum) {
      store.dispatch('invalidateListArticle', pageNum)
      store.dispatch('getNewsPage', pageNum)
    }
  },
  created () {
    store.dispatch('getNewsPage', 1)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

div.news img {
    width: 100%;
    -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
    transition: opacity 0.35s, transform 0.5s
}

div.news {
    text-align:left
}

div.news img:hover {
	-webkit-transform: scale3d(1.1,1.1,1);
	transform: scale3d(1.1,1.1,1);
  box-shadow: 1px 1px 3px rgba(0,0,0,0.7)
}

.news-title {
    font-weight: 300;
    font-size:1.4em;
}

.news-infos {
  font-size : 0.65em;
}

.abstract {
  font-size:0.8em;
}

.pagination {
  display: inline-block;
  float: right;
}

.pagination a {
    color: black;
    padding: 8px 16px;
    text-decoration: none;
    border: 1px solid #ddd;
}
.pagination a.active {
    background-color: #4CAF50;
    color: white;
}

.left-bottom-link {
  float: left;
  font-size: 1rem;
}


</style>



// WEBPACK FOOTER //
// news-list-panel.vue?4881625a